import {
  Bell, CalendarDays, Camera, CheckCircle2, ClipboardList,
  DollarSign, Home, LayoutDashboard, Megaphone, Trophy, Users,
  Database, Send, Dumbbell, Crown, MessageSquare
} from "lucide-react";
import { rolePermissions } from "./data";

// Phase 3 — Grouped nav. Each item now declares a `group` so the sidebar
// can render them under collapsible section headers ("My Stuff", "Team",
// "Club", "Admin"). Groups + their order are defined below in NAV_GROUPS.
// The flat `nav` array (legacy consumers) is preserved in source order.
export const nav = [
  // MY STUFF
  { key: "dashboard",     label: "Command Center", icon: LayoutDashboard, group: "my" },
  { key: "messages",      label: "Messages",       icon: MessageSquare,   group: "my" },
  { key: "notifications", label: "Notifications",  icon: Send,            group: "my" },

  // TEAM
  { key: "schedule",      label: "Schedules",      icon: CalendarDays,    group: "team" },
  { key: "availability",  label: "Availability",   icon: CheckCircle2,    group: "team" },
  { key: "squad",         label: "Squads",         icon: ClipboardList,   group: "team" },
  { key: "practice",      label: "Practice",       icon: Dumbbell,        group: "team" },
  { key: "rankings",      label: "Rankings",       icon: Crown,           group: "team" },

  // CLUB
  { key: "members",       label: "Members",        icon: Users,           group: "club" },
  { key: "groups",        label: "Groups",         icon: Home,            group: "club" },
  { key: "teams",         label: "Teams",          icon: Trophy,          group: "club" },
  { key: "announcements", label: "Announcements",  icon: Megaphone,       group: "club" },
  { key: "media",         label: "Gallery",        icon: Camera,          group: "club" },

  // ADMIN
  { key: "finance",       label: "Finance",        icon: DollarSign,      group: "admin" },
  { key: "admin",         label: "Admin",          icon: Database,        group: "admin" }
];

// Ordered group definitions for the sidebar renderer.
export const NAV_GROUPS = [
  { key: "my",    label: "My Stuff" },
  { key: "team",  label: "Team" },
  { key: "club",  label: "Club" },
  { key: "admin", label: "Admin" }
];

export const can = (user, key) =>
  user.roles.some(r => rolePermissions[r]?.includes(key));
